import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
} from '@europrocurement/l2d-redux-utils';
import { getOrderParameters, Orders } from '@europrocurement/l2d-domain/utils/orders';
import {
    ConfigurationParameters as OffreConfigurationParameters,
    Configuration,
    CatalogueApi,
    CatalogueJsonldCatalogueReadCatalogueReadGrilleTarifaireCatalogueReadFull,
    CatalogueApiApiCataloguesGetCollectionRequest,
} from '../../../openApi/ApiOffre';
import { CATALOGS_GRILLE_TARIFAIRE_SLICE_NAME, OFFRE_REDUCER_NAME } from '../constants';

export type CatalogGrilleTarifaireApiObject =
    CatalogueJsonldCatalogueReadCatalogueReadGrilleTarifaireCatalogueReadFull;

export type CatalogsGrilleTarifaire = CatalogGrilleTarifaireApiObject;

export const mapperCatalogsGrilleTarifaire = function (catalogs: CatalogGrilleTarifaireApiObject) {
    return {
        ...catalogs,
    } as CatalogsGrilleTarifaire;
};

export function createCatalogsGrilleTarifaireSlice(configuration: OffreConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new CatalogueApi(conf);

    // apiPrescripteursCataloguesGetCollection
    const fetchCatalogsCollection: FetchCollectionData<CatalogGrilleTarifaireApiObject> = ({
        search,
        pagination: { page, itemsPerPage },
        xIdSociete,
        filters,
        orders,
    }) => {
        /** Field mapper : Map column field name with api filter name */
        const ordersSchema = {
            groupement: 'groupementLibelle',
            offre: 'offreLibelle',
        };

        /** Get collection default orders */
        const defaultOrders: Orders = {
            orderOffreLibelle: 'asc',
            orderGroupementLibelle: 'asc',
            orderNomCommercial: 'asc',
        };

        const orderParameters = getOrderParameters(orders, defaultOrders, ordersSchema);

        let multiFieldSearch;

        /**
         * Manage search filters.
         */
        if (search && search !== '') {
            multiFieldSearch = search;
        }

        const requestParameters: CatalogueApiApiCataloguesGetCollectionRequest = {
            page: page + 1,
            itemsPerPage,
            ...filters,
            domaineSocietesSocieteId: xIdSociete,
            ...orderParameters,
            multiFieldSearch,
        };

        return api
            .apiCataloguesGrilleTarifaireGetCollection(requestParameters)
            .then((res) => res.data)
            .catch((error) => {
                console.error(error);
            }) as Promise<ApiCollectionResponse<CatalogGrilleTarifaireApiObject>>;
    };

    const fetchCatalogsItem: FetchItemDataType<CatalogGrilleTarifaireApiObject> = ({ idItem }) =>
        api
            .apiCataloguesIdGet({ id: String(idItem) })
            .then((res) => res.data) as Promise<CatalogGrilleTarifaireApiObject>;

    const {
        slice: catalogsGrilleTarifaireSlice,
        dataSourcesThunks: catalogsGrilleTarifaireDataSourcesThunks,
    } = SliceFactory.createSlice<CatalogGrilleTarifaireApiObject, CatalogsGrilleTarifaire>(
        CATALOGS_GRILLE_TARIFAIRE_SLICE_NAME,
        OFFRE_REDUCER_NAME,
        [],
        fetchCatalogsCollection,
        fetchCatalogsItem,
        mapperCatalogsGrilleTarifaire,
    );

    return { catalogsGrilleTarifaireSlice, catalogsGrilleTarifaireDataSourcesThunks };
}
